import React, { useCallback, useState } from 'react';
import { Tooltip } from 'antd';
import infoIcon from '../assets/info.svg';

type Props = {
  tooltip: string;
};

const TOOLTIP_BODY_STYLE: React.CSSProperties = {
  boxSizing: 'border-box',
  maxWidth: 174,
  padding: '8px 12px',
  color: '#fff',
  fontFamily: 'var(--family-sans, "PingFang SC"), -apple-system, BlinkMacSystemFont, sans-serif',
  fontSize: 12,
  fontWeight: 400,
  lineHeight: '16px',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  background: '#262626',
  borderRadius: 4,
  border: '0.5px solid #404040',
};

export const TooltipIcon: React.FC<Props> = ({ tooltip }) => {
  const [open, setOpen] = useState(false);

  const handleClick = useCallback((event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
    }
  }, []);

  if (!tooltip) return null;

  return (
    <>
      <span
        className="rte-shop-date-info-icon"
        role="img"
        aria-label="提示"
        data-tooltip={tooltip}
        tabIndex={0}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        <img src={infoIcon} alt="" />
      </span>
      <Tooltip
        title={tooltip}
        open={open}
        trigger={[]}
        arrow={false}
        color="#262626"
        placement="top"
        classNames={{ root: 'rte-shop-date-tooltip' }}
        styles={{ body: TOOLTIP_BODY_STYLE }}
      >
        <span className="rte-shop-date-tooltip-anchor" aria-hidden="true" />
      </Tooltip>
    </>
  );
};

TooltipIcon.displayName = 'TooltipIcon';
